module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6Uly5"))).then(() => parcelRequire('d0iPb'));